import * as React from 'react';
import { useNavigate } from "react-router";
import { useContext } from "react";
import { AppContext } from "../../context/AppContext";

interface PanelProps {
  header?: string | React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  style?: any
}

/**
 * openDatePickerOnKey
 *
 * the date inputs in the chart panel footers are readOnly and their picker
 * only opens on its own ArrowDown shortcut; Enter and Space open it too so
 * the keyboard path matches the pointer one. while the picker is open its own
 * keydown handling wins (it stops propagation), so this only sees the closed
 * state
 * @param event
 */
export const openDatePickerOnKey = (event: React.KeyboardEvent<HTMLInputElement>) => {
  if (event.key !== "Enter" && event.key !== " ") {
    return;
  }

  // vanillajs-datepicker hangs its instance off the input element
  const datepicker = (event.currentTarget as any).datepicker;

  if (datepicker && !datepicker.active) {
    event.preventDefault();
    datepicker.show();
  }
};

export function Panel({ header, children, footer, style = {} }: PanelProps) {
  const navigate = useNavigate();
  const {
    I18N
  } = useContext(AppContext);

  return (
    <dia-panel style={ style }>
      { header && (
        <dia-panel-header>
          { window.location.pathname.split("/").length > 2 ?
          <button
            data-icon-only
            data-secondary
            data-small
            data-back
            title={ I18N.t("zurück") }
            onClick={ () => navigate(-1) }
          >
            <i data-icon-before="arrow-left" />
          </button> : '' }
          <h2>{ header }</h2>
        </dia-panel-header>
      ) }
      <dia-panel-content>
        { children }
      </dia-panel-content>
      { footer && (
        <dia-panel-footer data-panel-footer-align="right">
          { footer }
        </dia-panel-footer>
      ) }
    </dia-panel>
  );
}
